import { useState } from "react";
import "./App.css";
import ItsMeFrog from "./pages/itsMeFrog";
import AboutMe from "./components/aboutMe";

function App() {
  const [aboutRevealed, setAboutRevealed] = useState(false);

  function toggleAbout(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    setAboutRevealed(value => !value);
  }

  return (
    <div className="site-shell" id="top">
      <a className="skip-link" href="#main">Skip to content</a>
      <main id="main" tabIndex="-1">
        <div className="hero">
          <ItsMeFrog onAboutClick={toggleAbout} aboutRevealed={aboutRevealed} />
        </div>
        <AboutMe revealRequested={aboutRevealed} />
      </main>
      <footer className="site-footer">
        <img className="footer-signature" src="/images/made-with-love.webp" width="800" height="165" loading="lazy" decoding="async" alt="Made with love by Lindsay Zhang" />
        <a className="webring-link" href="https://se-webring.xyz/" target="_blank" rel="noopener noreferrer" aria-label="Software Engineering webring (opens in a new tab)">
          <img src="/images/se-webring.svg" width="36" height="28" alt="" />
        </a>
      </footer>
    </div>
  );
}

export default App;
